import '.c3{position:relative;}.ssr-plugin'
import '.a7{background-color:var(--palette-white);}.ssr-plugin'
import '.i1{border-radius:20px;}.ssr-plugin'
import '.a8{border:var(--border-subtle);}.ssr-plugin'
import '.c6{padding:1.5rem;}.ssr-plugin'
import '.a4{width:100%;}.ssr-plugin'
import '.i2{transition:box-shadow 0.2s ease;}.ssr-plugin'
import '.fl{width:2rem;}.ssr-plugin'
import '.fm{height:2rem;}.ssr-plugin'
import '.ds{border-radius:50%;}.ssr-plugin'
import '.i3{border:1px solid var(--palette-blue-800);}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.bk{flex-shrink:0;}.ssr-plugin'
import '.i4{margin-left:1rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'

export interface SubsidyCardProps {
  title: string
  description: string
  style?: Style
  onClick?: () => void
}

export const SubsidyCard = ({
  title,
  description,
  style,
  onClick,
}: SubsidyCardProps) => {
  return (
    <styled.div className="c3 a7 i1 a8 c6 a4 i2"
      data-testid="subsidy-card"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.08)',
            }
          : {},
        ...style,
      }}
    >
      <Column gap="0.625rem" alignItems="stretch">
        {/* Header Section */}
        <Row
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {/* Title */}
          <Title.H5 style={{ color: 'var(--palette-blue-800)' }}>
            {title}
          </Title.H5>

          {/* Circular Icon */}
          <div className="fl fm ds i3 d i f bk i4"
          >
            <FontAwesomeIcon
              icon={faArrowUpRight}
              style={{
                color: 'var(--palette-blue-800)',
                height: '1.25rem',
              }}
            />
          </div>
        </Row>

        {/* Body Section */}
        <Text.Medium
          style={{
            color: 'var(--palette-blue-600)',
          }}
        >
          {description}
        </Text.Medium>
      </Column>
    </styled.div>
  )
}
